export default __webpack_public_path__ + "static/media/Group 3.849c487a.svg";